import { render, staticRenderFns } from "./SelectVariant.vue?vue&type=template&id=bef470f8&scoped=true"
import script from "./SelectVariant.vue?vue&type=script&lang=js"
export * from "./SelectVariant.vue?vue&type=script&lang=js"
import style0 from "./SelectVariant.vue?vue&type=style&index=0&id=bef470f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef470f8",
  null
  
)

export default component.exports